import React from "react";
import "./TermsConditions.css";

export default function TermsConditions() {

  return (

    <div className="tc-container">

      {/* HEADER */}

      <div className="tc-header">
        <h1>Terms & Conditions</h1>
        
      </div>

      {/* CONTENT CARD */}

      <div className="tc-card">

        <p className="tc-intro">
          By accessing or using the Shooin Stars App, you agree to these Terms & Conditions.
          If you do not agree, please discontinue use of the App.
        </p>

        {/* 1 */}

        <h2>1. Nature of Services</h2>

        <p>Shooin Stars is an educational guidance and admission counseling platform.</p>

        <ul>
          <li>College cut-off and historical data</li>
          <li>College predictor and preference-related tools</li>
          <li>General college information (fees, intake, affiliation, placements)</li>
          <li>Counseling support and guidance</li>
        </ul>

        <p className="tc-note">
          All information and predictions are indicative only.
        </p>

        {/* 2 */}

        <h2>2. No Admission Guarantee</h2>

        <ul>
          <li>Shooin Stars does not guarantee admission, seat allotment, or eligibility.</li>
          <li>Admission depends on official cut-offs, category, seat availability and authority decisions.</li>
          <li>Users must verify information from official counseling portals.</li>
        </ul>

        {/* 3 */}

        <h2>3. Accuracy & Non-CAP Information Disclaimer</h2>

        <ul>
          <li>Data is sourced from official and publicly available sources.</li>
          <li>Non-CAP information may change due to rules, policy updates or institutional decisions.</li>
          <li>Updates will be provided whenever officially available.</li>
          <li>Shooin Stars is not responsible for delayed or withheld information by colleges.</li>
        </ul>

        {/* 4 */}

        <h2>4. User Responsibility</h2>

        <ul>
          <li>Users must provide accurate personal and academic information.</li>
          <li>Counseling insights are supportive, not authoritative.</li>
          <li>Misuse of the App is strictly prohibited.</li>
        </ul>

        {/* 5 */}

        <h2>5. Report Usage & Restrictions</h2>

        <ul>
          <li>Includes 5 College Predictor Reports + 3 Preference Form Reports (with multiple strategies).
Once exhausted, refresh quota by paying ₹999 (non-refundable). Full quota restored upon payment.</li>
          <li>Reports must not be shared, sold or redistributed.</li>
          <li>Violation may result in access termination and legal action.</li>
        </ul>

        {/* 6 */}

        <h2>6. Payments & No Refund Policy</h2>

        <ul>
          <li>Shooin Stars offers digital services only.</li>
          <li>All payments are final and non-refundable.</li>
          <li>Payment does not guarantee admission results.</li>
        </ul>

        {/* 7 */}

        <h2>7. No Donation / Management / NRI Seat Policy</h2>

        <ul>
          <li>Shooin Stars does NOT offer guaranteed or paid seats.</li>
          <li>Shooin Stars never calls users for admissions.</li>
          <li>Beware of fraudsters impersonating Shooin Stars.</li>
          <li>Third-party scams are not Shooin Stars' responsibility.</li>
        </ul>

        {/* 8 */}

        <h2>8. Intellectual Property</h2>

        <ul>
          <li>All content, software, tools and UI designs belong to Shooin Stars.</li>
          <li>Unauthorized copying or reuse is prohibited.</li>
        </ul>

        {/* 9 */}

        <h2>9. Limitation of Liability</h2>

        <ul>
          <li>No responsibility for admission outcomes.</li>
          <li>No liability for financial, academic or emotional losses.</li>
          <li>No responsibility for technical issues or downtime.</li>
        </ul>

        <p className="tc-note">
          Use of this platform is entirely at the user's own risk.
        </p>

        {/* 10 */}

        <h2>10. Third-Party Services</h2>

        <p>
          Shooin Stars may use third-party services such as payment gateways and video platforms.
          Shooin Stars is not responsible for their policies or performance.
        </p>

        {/* 11 */}

        <h2>11. Termination</h2>

        <p>
          Shooin Stars reserves the right to suspend or terminate access
          in case of misuse or violation of these Terms.
        </p>

        {/* 12 */}

        <h2>12. Governing Law & Jurisdiction</h2>

        <p>
          These Terms are governed by Indian law.
          All disputes will fall exclusively under Pune court jurisdiction.
        </p>

        {/* 13 */}

        <h2>13. Contact</h2>

        <p className="tc-contact">
          📧 Email:
          <a href="mailto:info@shooinstars.com">
            info@shooinstars.com
          </a>
        </p>

        {/* DISCLAIMER */}

        <div className="tc-disclaimer">
          <strong>Disclaimer:</strong> Shooin Stars is an educational guidance platform only.
          It is not a government authority, admission body or college.
        </div>

      </div>

    </div>

  );
}
